import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import './Toolbar.css';
import Logo from '../../Layout/Logo/Logo';
import NavIcon from '../NavIcon/NavIcon';
import { IconButton, TooltipHost, ContextualMenu } from '@fluentui/react';
import UserFace from '../UserFace/Userface';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import FormHandler from '../../Containers/FormHandler/FormHandler';

const Toolbar = (props) => {
    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const [formStartConfig, setFormStartConfig] = useState({});
    const [visibility, setVisibility] = useState(true);

    const linkRef = useRef(null);

    let navVisible = props.navVisible;
    let navIcon = null;

    const onShowContextualMenu = (ev) => {
        ev.preventDefault();
        setShowContextualMenu(true);
    };

    const onHideContextualMenu = () => setShowContextualMenu(false);

    const onChangePassword = () => {
        setFormConfig('mypassworduievent');
    };

    const onChangePreferences = () => {
        setFormConfig('preferenceuievent');
    };

    const setFormConfig = (uievent) => {
        setFormStartConfig({
            button: { UIEvent: uievent },
            containerVisibility: setVisibility,
        });
    };

    const menuItems = [];
    if (props.uievents !== undefined) {
        if (
            props.uievents.find(
                (e) => e.Name.toLowerCase() === 'mypassworduievent'
            )
        ) {
            menuItems.push({
                key: 'changePassword',
                text: TranslateTag('@UseChaC@', props.language),
                onClick: onChangePassword,
            });
        }
        if (
            props.uievents.find(
                (e) => e.Name.toLowerCase() === 'preferenceuievent'
            )
        ) {
            menuItems.push({
                key: 'preferences',
                text: TranslateTag('@UsePre@', props.language),
                onClick: onChangePreferences,
            });
        }
    }

    let userIcon = (
        <div
            className="toolbar-cursor"
            onClick={onShowContextualMenu}
            ref={linkRef}
        >
            <UserFace username={props.username}></UserFace>
            <ContextualMenu
                items={menuItems}
                hidden={!showContextualMenu}
                target={linkRef}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
            />
        </div>
    );

    let logOff = (
        <TooltipHost
            content={TranslateTag('@GenLog@', props.language)}
            id={999}
        >
            <IconButton
                iconProps={{ iconName: 'SignOut' }}
                onClick={props.logOut}
                styles={{
                    root: { height: '40px', verticalAlign: 'middle' },
                }}
            ></IconButton>
        </TooltipHost>
    );
    if (props.loginVisible) {
        navVisible = false;
        userIcon = null;
        logOff = null;
    }

    navIcon = <NavIcon clicked={props.clicked} visible={navVisible}></NavIcon>;

    return (
        <header className="toolbar-header">
            <div className="toolbar-content">
                <div className="toolbar-left">
                    {navIcon}
                    <Logo></Logo>
                </div>
                <div className="toolbar-right">
                    {userIcon}
                    {logOff}
                </div>
            </div>
            <FormHandler startConfig={formStartConfig}></FormHandler>
        </header>
    );
};

const mapStateToProps = (state) => {
    return {
        language: state.config.language,
        uievents: state.config.uievents,
    };
};

export default connect(mapStateToProps)(Toolbar);
